export const COMPLAINTS_POINT_RADIUS = 30;
